// extracted by mini-css-extract-plugin
module.exports = {"background":"App_healthgenom_background__sVpwY"};